import type { UnpostedItem } from "~/store/availabilitySlice";

const computeAvailabilityPendingCount = (
	queuedCount: number,
	failedCount: number,
	unpostedCounts: Record<string, UnpostedItem[]> | null | undefined
): number => {
	const counts = unpostedCounts ?? {};
	const unpostedCount = Object.values(counts).reduce((sum, items) => sum + items.length, 0);
	return queuedCount + failedCount + unpostedCount;
};

export default computeAvailabilityPendingCount;
